// @flow

export const VideoStatus = {
  UNAVAILABLE: "UNAVAILABLE",
  STARTED: "STARTED",
  START_SOON: "START_SOON"
};

export default VideoStatus;
